import {IconName} from '../../../../libs/shared/ui/src/components/icon/icon';
import {EmojiDefinitionAndSkinTone} from '../../../../srcCommon/helpers/emoji/emojiTextHelpers';
import {TableColumn} from '../../../components/common/table/tableColumn';
import {StringOrTemplate} from '../../editors/commons/stringTemplateModel';
import {PreExpression} from '../../editors/expressions/expressionModel';

export enum ResourceTableColumnTypesEnum {
  DATE = 'date',
  NAME = 'name',
  STRING_TEMPLATE = 'stringTemplate',
  TEXT = 'text',
}

interface ResourceColumnBase extends TableColumn<ResourceTableColumnTypesEnum> {}

interface ResourceDateColumn<T> extends ResourceColumnBase {
  type: ResourceTableColumnTypesEnum.DATE;
  accessor: (item: T) => number;
  customFormat?: Intl.DateTimeFormatOptions;
}

interface ResourceNameColumn<T> extends ResourceColumnBase {
  type: ResourceTableColumnTypesEnum.NAME;
  accessor: (item: T) => string;
  iconName?: IconName;
  emojiDefinitionAccessor?: (item: T) => EmojiDefinitionAndSkinTone | undefined;
}

interface ResourceStringTemplateColumn<T> extends ResourceColumnBase {
  type: ResourceTableColumnTypesEnum.STRING_TEMPLATE;
  accessor: (item: T) => StringOrTemplate;
  expressionsAccessor: (item: T) => ReadonlyArray<PreExpression>;
}

interface ResourceTextColumn<T> extends ResourceColumnBase {
  type: ResourceTableColumnTypesEnum.TEXT;
  accessor: (item: T) => string;
}

export type ResourceColumn<T> =
  | ResourceDateColumn<T>
  | ResourceNameColumn<T>
  | ResourceStringTemplateColumn<T>
  | ResourceTextColumn<T>;
